export const EMAIL_REGEX =
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

export const PHONE_REGEX =
  /(?:\b|\()(?:\d{3})\)?[-. ]?(?:\d{3})[-. ]?(?:\d{4})\b/g;

export const URL_REGEX =
  /(?:[hH][tT][tT][pP][sS]?):\/\/(?:[wW]{3}\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|(?:[wW]{3}\.)?[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}/;

export const COMBINED_REGEX = new RegExp(
  `(${PHONE_REGEX.source})|(${URL_REGEX.source})|(${EMAIL_REGEX.source})`,
  'g'
);
